import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { fetchAllCategoryProductsAsync } from "../features/listingPage/listingPageSlice";
import { shopByCtgData } from "../data";

export const CtgCard = ({ userDetail, category }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFetchCategoryProduct = (catID, catName) => {
    dispatch(fetchAllCategoryProductsAsync(catID)).then(() => {
      navigate(`/listing-page/${catID}/${catName}`);
    });
  };

  const handleBrandNavigate = (brand, e) => {
    e.preventDefault();
    navigate(`/listing-page/${brand}`);
    e.stopPropagation();
  };
  return (
    <div
      key={category.id}
      className=" w-full sm:w-[30vw] h-[90vw] sm:h-[30vw] relative cursor-pointer overflow-hidden group before:bg-black-600"
      onClick={() =>
        handleFetchCategoryProduct(category.categoryID, category?.category)
      }
    >
      <img
        src={category.background}
        alt={category.category}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
      />
      {/* Radial Gradient Overlay (visible over image) */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.55)_0%,rgba(0,0,0,0.8)_80%)] opacity-70 group-hover:opacity-90 transition-all duration-500 z-[1]"></div>
      <img
        loading="lazy"
        src={category?.brandLogo}
        alt={category?.brandName}
        className="absolute bottom-[20px] left-[20px] max-sm:h-[40px] h-[30px] md:h-[40px] max-sm:min-w-[100px] min-w-[80px] md:min-w-[100px] object-cover z-10 opacity-0 transform translate-y-full transition-opacity duration-300 ease-in-out group-hover:opacity-100 group-hover:translate-y-0 bg-white"
        onClick={(e) => handleBrandNavigate(category?.brandName, e)}
      />
      <span className="absolute bottom-[20px] text-center right-[20px] max-sm:text-[20px] text-[16px] uppercase tracking-wider font-extrabold text-white z-10 group-hover:top-[50%] group-hover:left-1/2 group-hover:transform group-hover:-translate-x-1/2 group-hover:-translate-y-1/2 group-hover:text-[40px] transition-all duration-300">
        {category?.category}
      </span>
      <span className="hidden group-hover:flex items-center absolute top-[55%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 text-20 font-bold text-white tracking-wide transition-opacity duration-300 whitespace-nowrap">
        {category?.margin}% Off
      </span>
    </div>
  );
};
const ShopByCtgCard = () => {
  return (
    <section className="w-full bg-white flex flex-col items-center py-6 px-4">
      {/* Title */}
      <h2 className="text-xl font-extrabold text-blue mb-6 uppercase tracking-wide">
        Shop by Category
      </h2>

      {/* Vertical Cards */}
      <div className="flex flex-col items-center w-full">
        {shopByCtgData?.map((category) => (
          <CtgCard key={category.id} category={category} />
        ))}
      </div>
    </section>
  );
};

export default ShopByCtgCard;
